import { ADD_AI_REQUESTS, REMOVE_AI_REQUESTS, UPDATE_AI_REQUESTS } from '../types'

const state = {
  cacheAIRequests: [],
}

const getters = {
  cacheAIRequests: state => state.cacheAIRequests,
}

const mutations = {
  [UPDATE_AI_REQUESTS](state, aiRequests) {
    state.cacheAIRequests = aiRequests ?? []
  },
  [ADD_AI_REQUESTS](state, aiRequests) {
    const arr = [...state.cacheAIRequests]
    arr.push(aiRequests)
    state.cacheAIRequests = arr
  },
  [REMOVE_AI_REQUESTS](state, index) {
    const arr = [...state.cacheAIRequests]
    if (index !== -1) {
      arr.splice(index, 1)
    }
    state.cacheAIRequests = arr
  },
}

export default {
  state,
  getters,
  mutations,
}
